import { Button } from '@/components/ui/button';
import {
  SalesRepSelectors,
  type SalesRepSelectorsProps,
} from './sales-reps-selectors';

export function SalesRepSelectorsButton(props: SalesRepSelectorsProps) {
  return (
    <Button variant="outline" className="p-0 h-fit">
      <SalesRepSelectors {...props} />
    </Button>
  );
}
